import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Secure & Protected',
      description: 'Your data is encrypted with 256-bit SSL security'
    },
    {
      icon: 'Users',
      title: 'Verified Agents',
      description: 'All travel agents are professionally verified'
    },
    {
      icon: 'Clock',
      title: 'Quick Setup',
      description: 'Start planning your holiday in under 2 minutes'
    },
    {
      icon: 'Heart',
      title: 'Trusted by Thousands',
      description: 'Join 50,000+ happy travelers worldwide'
    }
  ];

  const securityBadges = [
    {
      icon: 'Shield',
      text: 'SSL Secured'
    },
    {
      icon: 'Lock',
      text: 'GDPR Compliant'
    },
    {
      icon: 'CheckCircle',
      text: 'UK Registered'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Main Trust Features */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature?.icon} size={20} className="text-primary" />
            </div>
            <div>
              <h4 className="font-medium text-foreground mb-1">{feature?.title}</h4>
              <p className="text-sm text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Security Badges */}
      <div className="pt-6 border-t border-border">
        <div className="flex flex-wrap items-center justify-center gap-4">
          {securityBadges?.map((badge, index) => (
            <div key={index} className="flex items-center space-x-2 px-3 py-2 bg-muted rounded-lg">
              <Icon name={badge?.icon} size={16} className="text-success" />
              <span className="text-sm font-medium text-foreground">{badge?.text}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Privacy Assurance */}
      <div className="bg-accent/10 rounded-lg p-4 text-center">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Icon name="ShieldCheck" size={20} className="text-accent" />
          <h4 className="font-medium text-foreground">Your Privacy Matters</h4>
        </div>
        <p className="text-sm text-muted-foreground">
          We never share your personal information with third parties. Your data is used solely to connect you with verified travel agents for your enquiries.
        </p>
      </div>
      {/* Contact Support */}
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-2">
          Need help? Our support team is here for you
        </p>
        <div className="flex items-center justify-center space-x-4 text-sm">
          <a href="mailto:support@holiyay.com" className="flex items-center space-x-1 text-primary hover:underline">
            <Icon name="Mail" size={14} />
            <span>support@holiyay.com</span>
          </a>
          <a href="tel:+442071234567" className="flex items-center space-x-1 text-primary hover:underline">
            <Icon name="Phone" size={14} />
            <span>+44 207 123 4567</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;